import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from '../lib/api-client';

export interface Address {
  id: number;
  label: string;
  name: string;
  phone: string;
  street: string;
  city: string;
  region: string;
  postalCode?: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export const addressService = {
  async getAll(): Promise<Address[]> {
    const response = await apiGet<Address[]>('/addresses');
    return response;
  },

  async create(data: Omit<Address, 'id' | 'createdAt' | 'updatedAt'>): Promise<Address> {
    const response = await apiPost<Address>('/addresses', data);
    return response;
  },

  async update(id: number, data: Partial<Address>): Promise<Address> {
    const response = await apiPut<Address>(`/addresses/${id}`, data);
    return response;
  },

  async delete(id: number): Promise<void> {
    await apiDelete(`/addresses/${id}`);
  },

  async setDefault(id: number): Promise<Address> {
    const response = await apiPatch<Address>(`/addresses/${id}/default`);
    return response;
  },
};